import { MySettingsResponse } from '../typings';

export const MOCK_ME: MySettingsResponse = {
  email: 'test@test.pl',
  first_name: 'Test',
  last_name: 'Testowy',
  public_key: '',
};
